/* eslint-disable @repo/no-style-props */
import * as React from "react";

import { cn } from "@/src/utils/tailwind";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  allowPasswordManager?: boolean;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, allowPasswordManager = false, ...props }, ref) => {
    return (
      <input
        {...(!allowPasswordManager && { "data-1p-ignore": true })}
        type={type}
        className={cn(
          "border-input bg-background placeholder:text-muted-foreground disabled:bg-muted/50 flex h-8 w-full min-w-14 rounded-md border px-2 py-1 text-sm file:border-0 file:bg-transparent file:text-sm file:font-bold focus:ring-0 focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
